import { innerSearch } from 'api/Api';
import React, { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import { useLocation, useNavigate } from 'react-router-dom';

interface ReturnForm {
  resultStatus: string;
  resultMessage: string;
  resultCode: string;
  tid: string;
  orderId: string;
  mallReserved: string;
  schemeGroup: string;
  schemeCode: string;
  approvalNo?: string;
  paymentUrl?: string;
}

const EcontextOutcome = () => {
  const searchParams = useLocation().search;
  const navigate = useNavigate();
  const [resultForm, setResultForm] = useState<ReturnForm>();
  const [returnUrl, setReturnUrl] = useState<string>('');

  const paramTid = new URLSearchParams(searchParams).get('tid');
  const paramPayUrl = new URLSearchParams(searchParams).get('payUrl');
  const approvalNo = new URLSearchParams(searchParams).get('approvalNo');

  // InnerSearch 실행
  const transactResult = useMutation(() => innerSearch(paramTid), {
    onSuccess: data => {
      if (
        data.data.response.resultStatus === null ||
        data.data.response.resultStatus === undefined
      ) {
        navigate('/error');
      } else {
        // returnUrl Set
        setReturnUrl(data.data.returnUrl);
        // 결과 Form 지정
        if (paramPayUrl && approvalNo)
          setResultForm({
            resultStatus: data.data.response.resultStatus,
            resultMessage: data.data.response.resultMessage,
            resultCode: data.data.response.resultCode,
            tid: data.data.response.tid,
            orderId: data.data.response.orderId,
            mallReserved: data.data.response.mallReserved,
            approvalNo: approvalNo as string,
            paymentUrl: paramPayUrl as string,
            schemeGroup: data.data.response.schemeGroup,
            schemeCode: data.data.response.schemeCode,
          });
        else {
          setResultForm({
            resultStatus: data.data.response.resultStatus,
            resultMessage: data.data.response.resultMessage,
            resultCode: data.data.response.resultCode,
            tid: data.data.response.tid,
            orderId: data.data.response.orderId,
            mallReserved: data.data.response.mallReserved,
            schemeGroup: data.data.response.schemeGroup,
            schemeCode: data.data.response.schemeCode,
          });
        }
      }
    },
    onError: error => {
      navigate('/error');
    },
  });

  const createFormAndSubmit = formData => {
    const form = document.createElement('form');
    form.setAttribute('method', 'POST');
    form.setAttribute('action', `${returnUrl}`);
    form.style.display = 'none';
    Object.entries(formData).forEach(([key, value]) => {
      const input = document.createElement('input');
      input.setAttribute('type', 'hidden');
      input.setAttribute('name', key);
      input.setAttribute('value', String(value));
      form.appendChild(input);
    });
    document.body.appendChild(form);
    form.submit();
  };

  useEffect(() => {
    if (paramTid) {
      transactResult.mutate();
    }
  }, []);

  useEffect(() => {
    if (resultForm) {
      createFormAndSubmit(resultForm);
    }
  }, [resultForm]);

  return <></>;
};

export default EcontextOutcome;
